import {Trans} from '@lingui/macro';
import React from 'react';

import {VirtualTableColumnCellsEnum} from '../../../../components/common/table/helpers/tableHelpers';
import {TableColumn} from '../../../../components/common/table/tableColumn';

/*
 * Constants.
 */

export const developersApiTokensTableNameColumnId = 'developers-api-tokens-table-name';
export const developersApiTokensTableScopeColumnId = 'developers-api-tokens-table-scope';
export const developersApiTokensTableLastActivityColumnId = 'developers-api-tokens-table-last-activity';
export const developersApiTokensTableCreatorColumnId = 'developers-api-tokens-table-creator';

export enum DevelopersApiTokensTableColumnsEnum {
  NAME = 'name',
  SCOPE = 'scope',
  LAST_ACTIVITY = 'last_activity',
  CREATOR = 'creator',
}

export const developersApiTokensTableColumns: ReadonlyArray<
  TableColumn<DevelopersApiTokensTableColumnsEnum>
> = [
  {
    id: developersApiTokensTableNameColumnId,
    title: <Trans id="developers-api-tokens-table-column-name">Name</Trans>,
    type: DevelopersApiTokensTableColumnsEnum.NAME,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: 0,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
        minWidth: 350,
        maxWidth: 350,
      },
    },
  },
  {
    id: developersApiTokensTableScopeColumnId,
    title: <Trans id="developers-api-tokens-table-column-scope">Scope</Trans>,
    type: DevelopersApiTokensTableColumnsEnum.SCOPE,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        minWidth: 250,
        maxWidth: 250,
      },
    },
  },
  {
    id: developersApiTokensTableLastActivityColumnId,
    title: <Trans id="developers-api-tokens-table-column-last-activity">Last activity</Trans>,
    type: DevelopersApiTokensTableColumnsEnum.LAST_ACTIVITY,
    cellType: VirtualTableColumnCellsEnum.DATE,
    settings: {
      cellWidth: {
        minWidth: 152,
        maxWidth: 152,
      },
    },
  },
  {
    id: developersApiTokensTableCreatorColumnId,
    title: <Trans id="developers-api-tokens-table-column-creator">Creator</Trans>,
    type: DevelopersApiTokensTableColumnsEnum.CREATOR,
    cellType: VirtualTableColumnCellsEnum.TEAMMATE,
    settings: {
      cellWidth: {
        minWidth: 180,
        maxWidth: 180,
      },
    },
  },
];
